module.exports = __webpack_public_path__ + "img/question_answer_black.91680dbe.svg";